module.exports = __webpack_public_path__ + "img/github@3x.10f8adf6.jpg";